/**
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<Array<Error|T>>}
 */
module.exports = function to(promise) {
  return promise.then(data => [null, data]).catch(err => [err])
}
